import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "spinnerTemplate"]

  connect() {
    this.boundShow = this.show.bind(this)
    this.boundHide = this.hide.bind(this)

    document.addEventListener("turbo:before-fetch-request", this.boundShow)
    document.addEventListener("turbo:before-fetch-response", this.boundHide)
    document.addEventListener("turbo:before-frame-render", this.boundHide)
    document.addEventListener("turbo:render", this.boundHide)
    document.addEventListener("turbo:load", this.boundHide)
    document.addEventListener("turbo:frame-load", this.boundHide)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.boundShow)
    document.removeEventListener("turbo:before-fetch-response", this.boundHide)
    document.removeEventListener("turbo:before-frame-render", this.boundHide)
    document.removeEventListener("turbo:render", this.boundHide)
    document.removeEventListener("turbo:load", this.boundHide)
    document.removeEventListener("turbo:frame-load", this.boundHide)
  }

  show(event) {
    // Ignore prefetch requests from Turbo 8
    const headers = event.detail.fetchOptions?.headers
    const isPrefetch = headers instanceof Headers ? 
      headers.has("X-Turbo-Prefetch") : 
      headers?.["X-Turbo-Prefetch"]

    if (isPrefetch) return

    const frame = event.detail.frame
    if (frame) {
      // For component reloads (Turbo Frames)
      frame.classList.add("relative")
      if (!frame.classList.contains("min-h-[100px]")) {
        frame.classList.add("min-h-[100px]")
      }
      
      let spinner = frame.querySelector(".admin-frame-spinner")
      if (!spinner && this.hasSpinnerTemplateTarget) {
        const content = this.spinnerTemplateTarget.content.cloneNode(true)
        frame.appendChild(content)
      } else if (spinner) {
        spinner.classList.remove("hidden")
      }
    } else {
      // For full page loads
      this.overlayTarget.classList.remove("hidden")
    }
  }

  hide(event) {
    const frame = event.detail.frame || (event.target && event.target.closest ? event.target.closest("turbo-frame") : null)
    if (frame) {
      const spinner = frame.querySelector(".admin-frame-spinner")
      if (spinner) spinner.classList.add("hidden")
    }
    
    this.overlayTarget.classList.add("hidden")
  }
}
